'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListGroup = require('react-bootstrap/lib/ListGroup');

var _ListGroup2 = _interopRequireDefault(_ListGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ListGroup2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/ListGroup.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/ListGroup.js
 ** module chunks = 0
 **/